import { render, staticRenderFns } from "./AddChargebackModal.vue?vue&type=template&id=4a773eaa&scoped=true&"
import script from "./AddChargebackModal.vue?vue&type=script&lang=js&"
export * from "./AddChargebackModal.vue?vue&type=script&lang=js&"
import style0 from "./AddChargebackModal.vue?vue&type=style&index=0&id=4a773eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a773eaa",
  null
  
)

export default component.exports